import { UIHeading4, UIText2, IconClose12, LinkButton, Spinner } from '@cian/ui-kit';
import cn from 'clsx';
import * as React from 'react';

import * as styles from './styles.css';
import { IEstimationHistoryItem } from '../../../types/redux/estimationHistory';
import { DiffIcon } from '../DiffIcon';

interface ICardProps {
  className?: string;
  estimation: IEstimationHistoryItem;
  onEstimationDelete(): void;
  onRedirectToReportClick(url: string): void;
  isDeleting?: boolean;
  testId?: string | number;
}

export const Card: React.VFC<ICardProps> = props => {
  const { estimation, className, onEstimationDelete, isDeleting, testId, onRedirectToReportClick } = props;
  const { url, dealType, priceDiff, title, address } = estimation;

  return (
    <div className={cn(styles['container'], className)} data-name={`estimation_${testId}`}>
      <div className={styles['flex']}>
        <div className={styles['left']}>
          <UIText2 color="gray60_100">{dealType}</UIText2>
          <UIHeading4>{title}</UIHeading4>
          <UIText2 color="gray60_100">{address}</UIText2>
        </div>
        <DiffIcon className={styles['icon']} diff={priceDiff} />
      </div>
      {url && (
        <div className={styles['button']}>
          <LinkButton theme="fill_secondary" size="M" href={url} fullWidth onClick={() => onRedirectToReportClick(url)}>
            Посмотреть отчёт
          </LinkButton>
        </div>
      )}
      <div className={styles['round']}>
        {isDeleting ? (
          <Spinner display="block" size={12} />
        ) : (
          <button type="button" className={styles['close']} onClick={onEstimationDelete} data-name="delete">
            <IconClose12 display="block" color="gray60_100" />
          </button>
        )}
      </div>
    </div>
  );
};
